import { render, staticRenderFns } from "./UserRecharge.vue?vue&type=template&id=5d0960c6"
import script from "./UserRecharge.vue?vue&type=script&lang=js"
export * from "./UserRecharge.vue?vue&type=script&lang=js"
import style0 from "./UserRecharge.vue?vue&type=style&index=0&id=5d0960c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports